import styles from "./SettingsAutopaySubscriptionPage.module.css";
import { useSettingsAutopaySubscriptionViewModel } from "@/features/settings/viewModal/useSettingsAutopaySubscriptionViewModel";

export const SettingsAutopaySubscriptionPage = () => {
  const { loading, cards } = useSettingsAutopaySubscriptionViewModel();

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>
        Auto-Pay <span className={styles.titleAccent}>Subscriptions</span>
      </h1>

      <section className={styles.infoBanner}>
        Your subscriptions will automatically renew each year. You can cancel anytime, and your
        subscription will remain active until the end of the current billing period.
      </section>

      {loading && <section className={styles.subscriptionCard}>Loading subscriptions...</section>}

      {!loading && cards.length === 0 && (
        <section className={styles.subscriptionCard}>No subscriptions found.</section>
      )}

      {cards.map((card) => {
        return (
          <article key={card.key} className={styles.subscriptionCard}>
            <div className={styles.cardHeader}>
              <span className={styles.homeIcon} aria-hidden="true">
                &#127968;
              </span>
              <h2 className={styles.address}>{card.propertyAddress}</h2>
            </div>

            <div className={styles.propertyId}>Property ID: {card.propertyId}</div>
            <div className={styles.activePill}>{card.isActive ? "Active" : "Inactive"}</div>

            <div className={styles.metaRow}>
              <span aria-hidden="true">&#128197;</span>
              <span>Renewal Date: {card.renewalDateLabel}</span>
            </div>
            <div className={styles.metaRow}>
              <span aria-hidden="true">$</span>
              <span>Annual Fee: {card.annualFeeLabel}</span>
            </div>

            <button
              type="button"
              disabled={!card.isActive || !card.subscriptionId || card.isCanceling}
              className={`${styles.actionBtn} ${card.isActive ? styles.cancelBtn : styles.setBtn}`}
              onClick={() => void card.onCancel()}
            >
              {card.isCanceling ? "Canceling..." : card.isActive ? "Cancel Auto-Pay" : "Cancelled"}
            </button>
          </article>
        );
      })}
    </div>
  );
};
